// ⚠️⚠️⚠️⚠️ DO NOT EDIT ⚠️⚠️⚠️⚠️
// This file was automatically generated, run pnpm gen:gql to update it
/* eslint-disable */

import type * as Types from '../../../schema/public';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type LoggedOutBannerQueryVariables = Types.Exact<{
  filter?: Types.InputMaybe<Types.ContentPageConnectionFilter>;
}>;


export type LoggedOutBannerQuery = { __typename?: 'Query', content?: { __typename?: 'Content', id: string, promos?: { __typename?: 'ContentPageConnection', edges?: Array<{ __typename?: 'ContentPageEdge', node?: { __typename?: 'ContentPage', id: string, mainBlock?: string, handle?: string } }> } } };


export const LoggedOutBannerQueryDocument = /*#__PURE__*/ gql`
    query LoggedOutBannerQuery($filter: ContentPageConnectionFilter) {
  content {
    id
    promos: pages(filter: $filter, sort: {publishDate: 1}, first: 1) {
      edges {
        node {
          id
          mainBlock
          handle
        }
      }
    }
  }
}
    `;
export function useLoggedOutBannerQuery(baseOptions?: Apollo.QueryHookOptions<LoggedOutBannerQuery, LoggedOutBannerQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<LoggedOutBannerQuery, LoggedOutBannerQueryVariables>(LoggedOutBannerQueryDocument, options);
      }
export function useLoggedOutBannerQueryLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<LoggedOutBannerQuery, LoggedOutBannerQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<LoggedOutBannerQuery, LoggedOutBannerQueryVariables>(LoggedOutBannerQueryDocument, options);
        }
export function useLoggedOutBannerQuerySuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<LoggedOutBannerQuery, LoggedOutBannerQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<LoggedOutBannerQuery, LoggedOutBannerQueryVariables>(LoggedOutBannerQueryDocument, options);
        }
export type LoggedOutBannerQueryHookResult = ReturnType<typeof useLoggedOutBannerQuery>;
export type LoggedOutBannerQueryLazyQueryHookResult = ReturnType<typeof useLoggedOutBannerQueryLazyQuery>;
export type LoggedOutBannerQuerySuspenseQueryHookResult = ReturnType<typeof useLoggedOutBannerQuerySuspenseQuery>;
export type LoggedOutBannerQueryQueryResult = Apollo.QueryResult<LoggedOutBannerQuery, LoggedOutBannerQueryVariables>;